import {
  ClipboardCheck,
  CalendarDays,
  FilePenLine,
  FileSearch,
  LayoutDashboard,
  Landmark,
  ScrollText,
  Settings,
  SlidersHorizontal,
  Newspaper,
  UserCog,
  UserCircle,
  Users,
  type LucideIcon,
} from "lucide-react"

export type NavItem = {
  label: string
  href: string
  icon: LucideIcon
  adminOnly?: boolean
  superAdminOnly?: boolean
}

export const NAV: NavItem[] = [
  { label: "Dashboard", href: "/dashboard", icon: LayoutDashboard },
  { label: "Applications", href: "/applications/", icon: ClipboardCheck },
  { label: "Borrowers", href: "/borrowers/", icon: Users },
  { label: "Loans", href: "/loans/", icon: Landmark },
  { label: "Staff", href: "/staff/", icon: UserCog, adminOnly: true },
  { label: "Audit log", href: "/audit/", icon: ScrollText },
  { label: "Compliance", href: "/compliance/", icon: FileSearch },
  { label: "Staff activity", href: "/staff-activity/", icon: CalendarDays, superAdminOnly: true },
  { label: "Loan engine", href: "/loan-engine/", icon: SlidersHorizontal, adminOnly: true },
  { label: "Website content", href: "/customise/", icon: FilePenLine, adminOnly: true },
  { label: "Blog", href: "/blog/", icon: Newspaper, adminOnly: true },
  { label: "Settings", href: "/settings/", icon: Settings, adminOnly: true },
  { label: "Profile", href: "/profile/", icon: UserCircle },
]

export const DetailIcon = FileSearch
